import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { blue } from "./constants";


const Job: React.FC<{
    title: string,
    company?: string,
    url?: string,
    description?: string,
    start: number,
    end?: number,
    protocol?: string,
    accomplishments?: string[],
    stack?: string[],
    last?: boolean,
}> = ({ title, company, url, description, start, end, protocol = 'https', accomplishments = [], stack, last = false }) => {

    return (
        <Box
            sx={{
                mt: 0,
                mb: 2
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    // flexDirection: 'row',
                    // justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    m: 0
                }}
            >
                <Box
                    component={'span'}
                    sx={{ m: 0 }}
                >
                    {start} - {end ? end : 'current'}
                </Box>
                <Box
                    component={'h4'}
                    sx={{
                        flex: 1,
                        m: 0,
                        pl: 1
                    }}
                >
                    {title}{company ? `, ${company}` : ''}
                </Box>

                {url && <Box
                    component={'p'}
                    sx={{ m: 0 }}
                >
                    <a href={`${protocol}://${url}`} style={{ color: blue }}>{`${protocol}://${url}`}</a>
                </Box>}
            </Box>

            <Box>
                {
                    stack?.map((item, index) => {
                        const separator = index < stack!.length - 1 ? ' \u2022 ' : '';
                        return <><b key={index}><i>{item}</i></b><span>{separator}</span></>
                    })
                }
            </Box>

            {description && <p style={{
                marginTop: 1,
                marginBottom: 4
            }}>
                {description}
            </p>}

            <ul
                style={{
                    listStylePosition: 'inside',
                    padding: 0,
                    margin: 0,
                }}
            >
                {
                    accomplishments.map((acc, index) => <li key={index}>{acc}</li>)
                }
            </ul>
        </Box>
    )
}

export default Job;